export const COVENTRY_ORIGIN = 'https://visa-monk.bookinterview.co.uk';

// Messages VisaMonk sends TO Coventry
export const COVENTRY_OUTBOUND_EVENTS = {
  INIT_INTERVIEW: 'INIT_INTERVIEW',
} as const;

// Messages Coventry sends TO VisaMonk
export const COVENTRY_INBOUND_EVENTS = {
  INTERVIEW_COMPLETED: 'INTERVIEW_COMPLETED',
  INTERVIEW_CLOSED: 'INTERVIEW_CLOSED',
  INTERVIEW_FAILED: 'INTERVIEW_FAILED',
  REQUEST_CANDIDATE_DATA: 'REQUEST_CANDIDATE_DATA',
} as const;